module.exports = __webpack_public_path__ + "static/media/icon-idea.7741f1e4.svg";